import {InputAdornment, OutlinedInput} from "@mui/material";
import {t} from "i18next";
import {useEffect} from "react";
import {WeightUnit} from "../../models";
import {formatWeight} from "./formik/weight-input";

export interface WeightInputProps {
    weight: string | null;
    setWeight: any;
    weightUnit: WeightUnit | null;
    setWeightUnit: any;
    units?: WeightUnit[];
}

export const convertToUnit = (value: string | null, unit: WeightUnit | null, targetUnit: WeightUnit | null) => {
    const numberValue = Number(value);
    if (numberValue != null && unit != null && targetUnit != null) {
        if (unit !== targetUnit) {
            if (unit === WeightUnit.Lb && targetUnit === WeightUnit.Kg) {
                return numberValue * 0.453592
            }
            if (unit === WeightUnit.Kg && targetUnit === WeightUnit.Lb) {
                return numberValue * 2.20462
            }
        }
    }
    return numberValue
}

export const WEIGHT_LIMIT_SHOPPING = "30.00";
export const WEIGHT_LIMIT_SHOPPING_UNIT = WeightUnit.Kg;

export default function WeightInput({
                                        weight,
                                        setWeight,
                                        weightUnit,
                                        setWeightUnit,
                                        units = [WeightUnit.Kg, WeightUnit.Lb]
                                    }: WeightInputProps) {


    const weightLimitConverted = formatWeight({
        value: WEIGHT_LIMIT_SHOPPING,
        unit: WEIGHT_LIMIT_SHOPPING_UNIT,
        targetUnit: weightUnit ?? WeightUnit.Kg
    });

    useEffect(() => {
        setWeight(formatWeight({
            value: weight ?? '',
            unit: weightUnit ?? WeightUnit.Kg,
            weightLimit: WEIGHT_LIMIT_SHOPPING,
            weightLimitUnit: WEIGHT_LIMIT_SHOPPING_UNIT,
            targetUnit: weightUnit ?? WeightUnit.Kg
        }))
    }, [weightUnit]);

    return <OutlinedInput
        sx={{width: "100%"}} inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
        placeholder={t(`weight.placeholder`, {
            weightLimit: weightLimitConverted,
            weightLimitUnit: t(`weight.${weightUnit?.toLowerCase()}`)
        })}
        value={weight}
        onChange={(event) => {
            setWeight(formatWeight({
                value: event?.target?.value,
                unit: weightUnit ?? WeightUnit.Kg,
                weightLimit: WEIGHT_LIMIT_SHOPPING,
                weightLimitUnit: WEIGHT_LIMIT_SHOPPING_UNIT,
                targetUnit: weightUnit ?? WeightUnit.Kg
            }))
        }}
        endAdornment={
            <InputAdornment position="end">
                {units?.map((unit) => {
                    return <div className={`weight-unit ${weightUnit === unit ? 'selected' : ''}`}
                                onClick={() => setWeightUnit(unit)}>{t(`weight.${unit.toLowerCase()}`)}
                    </div>
                })
                }
            </InputAdornment>
        }/>

}